import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Centralised <head> injection for each page.
 * Used for page-level SEO and OpenGraph share cards.
 */
export default function SEO({
  title,
  description,
  image,
  canonical,
  type = "website",
}) {
  const siteTitle = "Fruit Blossoms · Jamaican Fruit Pops";
  const fullTitle = title ? `${title} · Fruit Blossoms` : siteTitle;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
